var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMap = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M7.27 26.52h17.46v2.46H7.27zm6.21-15q0 1.02.75 1.74c.75.72 1.095.72 1.785.72s1.28-.24 1.77-.72.735-1.06.735-1.74q0-1.02-.75-1.77C17.02 9 16.68 9 16 9q-1.02 0-1.77.75c-.75.75-.75 1.09-.75 1.77m10.02 0q0 1.56-.78 3.57-.66 1.71-1.86 3.69-.96 1.56-2.22 3.24-.9 1.2-1.86 2.31l-.78.9-.78-.9q-.96-1.11-1.86-2.31-1.26-1.68-2.22-3.24-1.2-1.98-1.86-3.69-.78-2.01-.78-3.57 0-2.04 1.005-3.765a7.45 7.45 0 0 1 2.73-2.73A7.35 7.35 0 0 1 16 4.02q2.04 0 3.765 1.005t2.73 2.73A7.35 7.35 0 0 1 23.5 11.52"
})));
export default SvgMap;